/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ConfigService } from './../../../core/services/config.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { StaticDataStoreService } from '../../../core/services/static-datastore.service';
import { MenuItem } from 'primeng/api';
import { UserService } from '../../../core/services/user.service';

/**
 * @export
 * @class LocoStatusSubHeaderComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-status-sub-header',
  templateUrl: './loco-status-sub-header.component.html',
  styleUrls: ['./loco-status-sub-header.component.scss']
})

export class LocoStatusSubHeaderComponent implements OnChanges {
  
  @Input() locoStatusArr: Array<LocoDetail>;
  @Input() isSelectedLocos: boolean;
  @Input() isShowCancelLocoPlan: boolean;
  @Output() planOrCurrentAssignment = new EventEmitter<string>();
  @Output() cancelLocomotivePlan = new EventEmitter<boolean>();
  @Output() allocateDellocateEvent = new EventEmitter<String>();
  configData: any;
  tabIndex: number;
  otherOptions: MenuItem[]; // Top Action MenuItem
  allocateRole: string;
  /**
   * Creates an instance of LocoStatusSubHeaderComponent.
   * @memberOf LocoStatusSubHeaderComponent
   */
  constructor(private staticDataStoreService: StaticDataStoreService,
    private configService: ConfigService, 
    public user: UserService) {
    this.configData = this.configService.getConfigData();
    this.tabIndex = this.configData.tabIndex.subTabs;
    this.otherOptions = [];
    this.prepareOtherOptionsMenu();
    const commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    if (commonopsPicklist &&
      commonopsPicklist.masterData &&
      commonopsPicklist.masterData.userAuthDetails &&
      commonopsPicklist.masterData.userAuthDetails.allocationRole) {
      this.allocateRole = commonopsPicklist.masterData.userAuthDetails.allocationRole;
    }
  }

  ngOnChanges() {
    this.prepareOtherOptionsMenu();
  }

  /**
   * emits an event for open plan or set current assignment popup.
   * @param {string} value
   * @memberOf LocoStatusSubHeaderComponent
   */
  openPlanOrCurrentAssignmentPopup(value: string) {
    this.planOrCurrentAssignment.emit(value);
  }

  /**
   * emits an event for open cancel plan locomotive popup.
   * @memberOf LocoStatusSubHeaderComponent
   */
  openCancelLocomotivePlanPopup() {
    this.cancelLocomotivePlan.emit();
  }

  /**
   * Prepare Other Action Menu Item
   * @private
   */
  private prepareOtherOptionsMenu() {
    this.otherOptions = [
      {
        label: 'Allocate', command: () => {
          this.otherActionsTaken('allocate', 'Allocate');
        }, disabled: !this.isSelectedLocos || (this.user && !this.user.isUserManagerOrDirector) || (!this.allocateRole || (this.allocateRole && (this.allocateRole.toUpperCase().trim() !== 'YL' && this.allocateRole.toUpperCase().trim() !== 'MW')))
      },
      {
        label: 'Deallocate', command: () => {
          this.otherActionsTaken('deallocate', 'Deallocate');
        }, disabled: !this.isSelectedLocos || (this.user && !this.user.isUserManagerOrDirector) || (!this.allocateRole || (this.allocateRole && (this.allocateRole.toUpperCase().trim() !== 'YL' && this.allocateRole.toUpperCase().trim() !== 'MW')))
      }
    ];
  }

  /**
   * Actions taken on click from Menu Item
   * @param {string} type
   * @param {string} label
   */
  private otherActionsTaken(type: string, label: string) {
    if (type && (type == 'allocate')) {
      this.allocateDellocateEvent.emit('allocate');
    } else  if (type && (type == 'deallocate')){
      this.allocateDellocateEvent.emit('deallocate');
    }
  }
}


